import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ExcelReader from 'components/common/FileController/ExcelReader';
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { Table, Button, Select, Spin } from 'antd';
import PaginationComp from  'components/common/PaginationComp';
import { text_companyNm, text_columes } from 'lib/textChang';
import { COMPANY_TYPE, CE_TYPE } from 'constant';

@inject('centerInfoStore')
@observer
class CenterList extends Component {
  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.centerInfoStore.disCenterList(pageIdx);
  };

  onSearch = () => {
    this.props.centerInfoStore.disCenterList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      centerList,
      pageInfo,

      onChangValue,
      onViewMode, 
      onDetailData,
      disCenterList,
      useCenterYn,

      merCenterList,
      disPwReset,
      excelUploadIng,
      onExcelUploadIng,
    } = this.props.centerInfoStore;
    const { sessionLoginInfo, ceType  } = this.props;

    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '30px', align: 'center' },
      { title: '구분', dataIndex: 'ceType', width: '10%', key: '', align: 'center',
        render: (_, record) => { return(
          <Fragment>
            {record.ceType === CE_TYPE.CENTER &&
              <Fragment>센터</Fragment>
            }
            {record.ceType === CE_TYPE.BRANCH &&
              text_columes()
            }
            {(record.ceType === CE_TYPE.YUJIN || record.ceType === CE_TYPE.MASTER) &&
              <Fragment>관리자</Fragment>
            }
          </Fragment>
        )}
      },
      { title: text_companyNm(), dataIndex: 'ceBranchNm', align: 'center',
        render: (item) => { 
          if(sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ) {
            const sliceIdx = item?.indexOf('(');
            if(sliceIdx > 0 && item?.indexOf(')') > 0){
              return (item.slice(0, sliceIdx))
            }
          }
          return (item)
      }},
      { title: '지사', dataIndex: 'ceSubName', width: '15%', align: 'center' },
      { title: '센터', dataIndex: 'ceNm', width: '14%', align: 'center',
        render: (item, record) => { 
          if(sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ && record.ceType === CE_TYPE.BRANCH) {
            const sliceIdx = item?.indexOf('(');
            if(sliceIdx > 0 && item?.indexOf(')') > 0){
              return (item.slice(sliceIdx+1, item.length-1))
            }
          }
          return (item)
      }},
      { title: '코드', dataIndex: 'ceCd', width: '15%', align: 'center' },
      { title: '사용유무', dataIndex: 'ceUseYn', width: '10%', key: '', align: 'center',
        render: (item, record) => { return(
          (record.ceType !== CE_TYPE.YUJIN
            && record.ceType !== CE_TYPE.MASTER) && 
          <Button  
            onClick={(e)=>{
              e.stopPropagation();
              useCenterYn(record.ceCd, item);
            }}
          >{item === "Y" ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>}
          </Button>
        )}
      },
      { title: '비밀번호초기화', dataIndex: '', width: '15%', key: '', align: 'center',
        render: (item, record) => { return(       
          <Button 
            onClick={(e)=>{
              e.stopPropagation();
              disPwReset(record.ceCd);
            }}
          >초기화
          </Button>
        )}
      },
    ]
    return (
      <Spin
        tip="엑셀 업로드 중..." 
        spinning={excelUploadIng}
        size="large"
      >
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">{text_companyNm()}</span>
              <CenterOptionList
                allText={"전체"}
                onlyBranchCd={true}
                ceBranchCdValue={valCondition.ceBranchCd}
                eBranchCdChange={(value)=>{
                  onChangValue('ceBranchCd', value);
                  onChangValue('ceCd', '');
                  this.onSearch();
                }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">사용여부</span> 
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.ceUseYn}
                onChange={(value)=>{
                  onChangValue('ceUseYn', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                <Select.Option key={'Y'}>사용</Select.Option>
                <Select.Option key={'N'}>미사용</Select.Option>
              </Select>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disCenterList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          <div className="button-right">
            <ul>
              <li>
                <Fragment>
                {ceType === CE_TYPE.YUJIN   
                &&
                <Button
                  type="primary"
                  onClick={()=>onViewMode('add')}
                >추가</Button>
                }
                </Fragment>
              </li>
              <li>
                {/* 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-CENTER-LIST'}
                  schInfo={valCondition}
                />
              </li>
              {(ceType === CE_TYPE.YUJIN || ceType === CE_TYPE.MASTER)
              &&
              <Fragment>
                <li>
                  {/* 엑셀업로드 */}
                  <ExcelReader
                    actionType={'upload'}
                    excelUpload={(data)=>merCenterList(data.slice(1, data.length))}
                    onExcelUploadIng={(boolen)=>onExcelUploadIng(boolen)}
                  />
                </li>
                <li>
                  {/* 탬플릿다운로드 */}
                  <ExcelReader
                    actionType={'templet'}
                    pageUrl={'DOWN-CENTER-LIST'}
                    schInfo={valCondition}
                  />
                </li>
              </Fragment>
              }
            </ul>
          </div>
        </div>
  
        <Table
          rowKey={(record)=>record.RNUM}
          // columns={columns} 
          columns={
            ceType === CE_TYPE.YUJIN 
            ? (sessionLoginInfo?.cGbn === COMPANY_TYPE.KNP) 
              ? columns.filter(item=> item?.dataIndex !== 'ceSubName' && item?.dataIndex !== 'ceNm')
              : columns
            : (sessionLoginInfo?.cGbn === COMPANY_TYPE.KNP) 
              ? columns.slice(0, columns.length-1)
                      .filter(item=> item?.dataIndex !== 'ceSubName' && item?.dataIndex !== 'ceNm')
              : columns.slice(0, columns.length-1)
          } 
          dataSource={centerList} 
          //scroll={{ x: 1300, y:300 }}
          pagination={false}
          onRow={(record) => {
            return {
              onClick: e => {
                e.preventDefault();
                if (record.ceType !== CE_TYPE.YUJIN
                  && record.ceType !== CE_TYPE.MASTER) {
                    onDetailData(record);
                  }
                
              },
            };
          }}
        />
        <PaginationComp 
          pageInfo={pageInfo}
          onChange={this.onPageChange}
        />
      </Spin>
    );
  }

}

export default withRouter(CenterList);
